  <div style="display: flex;align-items: center;" *ngIf="available?.length > 1">
    <p class="select-label">{{label}} </p>
  <nb-form-field>

    <nb-select [(ngModel)]="selectedValue" placeholder="Select Instance" >
        
      <nb-option *ngFor="let option of available" [value]="option">{{option.title}}</nb-option>
    </nb-select>
  </nb-form-field>
  </div>